import { TAB_NUMBER } from '../../constants';
import { LiveData } from '../LiveData/LiveData';
import { StaticData } from '../StaticData/StaticData';

export const TabsRouter = ({ active }: { active: number }) => {
  if (active === TAB_NUMBER.STATIC) {
    return <StaticData />;
  }

  if (active === TAB_NUMBER.LIVE) {
    return <LiveData />;
  }

  return null;
};
